module.exports = __webpack_public_path__ + "static/media/screen3.4bd6166e.png";